import { extendTheme } from '@mui/joy/styles';

// Vector India brand theme
const theme = extendTheme({
  colorSchemes: {
    light: {
      palette: {
        primary: {
          50: '#fff3e6',
          100: '#ffe0cc',
          200: '#ffcc99',
          300: '#ffb366',
          400: '#ff9933',
          500: '#eb7a24', // Main Vector India orange
          600: '#d16000',
          700: '#b85000',
          800: '#9e4000',
          900: '#853000',
        },
        neutral: {
          50: '#f8f9fa',
          100: '#f1f3f4',
          200: '#e8eaed',
          300: '#dadce0',
          400: '#bdc1c6',
          500: '#9aa0a6',
          600: '#80868b',
          700: '#5f6368',
          800: '#3c4043',
          900: '#202124',
        },
        success: {
          500: '#28a745',
        },
        warning: {
          500: '#ffc107',
        },
        danger: {
          500: '#dc3545',
        },
      },
    },
  },
  fontFamily: {
    body: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
    display: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
  },
  components: {
    // Global border color and radius tightening
    JoyCssVarsProvider: {
      defaultProps: {},
    },
    JoyButton: {
      styleOverrides: {
        root: ({ theme, ownerState }) => ({
          borderRadius: '8px',
          fontWeight: 500,
          textTransform: 'none',
          fontSize: '14px',
          borderColor: theme.vars.palette.neutral[400],
          ...(ownerState.variant === 'solid' && ownerState.color === 'primary' && {
            background: 'linear-gradient(135deg, #eb7a24 0%, #f19b30 100%)',
            '&:hover': {
              background: 'linear-gradient(135deg, #d16000 0%, #e67700 100%)',
            },
          }),
        }),
      },
    },
    JoyCard: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: '12px',
          borderColor: theme.vars.palette.neutral[400],
          boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.12), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
        }),
      },
    },
    JoyInput: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: '8px',
          borderColor: theme.vars.palette.neutral[400],
        }),
      },
    },
    JoyCheckbox: {
      defaultProps: {
        variant: 'outlined',
        color: 'primary'
      },
      styleOverrides: {
        root: ({ theme }) => ({
          borderColor: theme.vars.palette.neutral[500],
          borderRadius: '6px',
          borderWidth: 1,
          borderStyle: 'solid',
          '--Icon-fontSize': '18px',
          '&:hover': {
            borderColor: theme.vars.palette.neutral[600],
          },
          // Checked state → use brand orange
          '&.Mui-checked, &[data-checked="true"]': {
            borderColor: theme.vars.palette.primary[600],
            backgroundColor: theme.vars.palette.primary[50],
            '--Checkbox-markBackground': theme.vars.palette.primary[500],
            '--Icon-color': '#fff'
          }
        }),
      },
    },
    JoyIconButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderColor: theme.vars.palette.neutral[400],
          borderWidth: 1,
          borderStyle: 'solid',
        }),
      },
    },
    JoyMenu: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderColor: theme.vars.palette.neutral[500],
          borderWidth: 1,
          borderStyle: 'solid',
          boxShadow: '0 6px 18px rgba(0,0,0,0.12)'
        }),
      },
    },
    JoyMenuItem: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderColor: theme.vars.palette.neutral[400],
          '&:hover': {
            backgroundColor: theme.vars.palette.neutral[100],
          }
        }),
      },
    },
    JoySelect: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderColor: theme.vars.palette.neutral[400],
        }),
      },
    },
    JoyTextarea: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderColor: theme.vars.palette.neutral[400],
        }),
      },
    },
    JoyModalDialog: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderColor: theme.vars.palette.neutral[400],
        }),
      },
    },
    JoySheet: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderColor: theme.vars.palette.neutral[400],
        }),
      },
    },
  },
});

export default theme;